import { jsx as _jsx } from "react/jsx-runtime";
import classes from './index.module.scss';
const LeftColumn = ({ children }) => _jsx("div", Object.assign({ "data-testid": "overview-layout-left", className: classes.leftColumn }, { children: children }), void 0);
const RightColumn = ({ children }) => _jsx("div", Object.assign({ "data-testid": "overview-layout-right", className: classes.rightColumn }, { children: children }), void 0);
const OverviewLayout = ({ children }) => {
    return (_jsx("div", Object.assign({ className: classes.overviewLayout }, { children: children }), void 0));
};
OverviewLayout.LeftColumn = LeftColumn;
OverviewLayout.RightColumn = RightColumn;
export default OverviewLayout;
//# sourceMappingURL=index.js.map